import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { PagoService } from '../../../services/pago.service';
import { UserService } from '../../../services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-paymentrun',
  templateUrl: './paymentrun.component.html',
  styleUrls: ['./paymentrun.component.css'],
  providers: [UserService, PagoService]
})
export class PaymentrunComponent implements OnInit , AfterViewInit {
  selectedFrequency: string = '';
  weekDays = [
    { value: 1, label: 'Monday' },
    { value: 2, label: 'Tuesday' },
    { value: 3, label: 'Wednesday' },
    { value: 4, label: 'Thursday' },
    { value: 5, label: 'Friday' },
    { value: 6, label: 'Saturday' },
    { value: 7, label: 'Sunday' }
  ];
  daysInMonth: number[] = Array.from({ length: 28 }, (_, i) => i + 1); // US payroll rarely uses >28
  daysSemiMonthly: (number ) [] = [1, 15];
  selectedWeekday: number | null = null;
  selectedBiweeklyWeekday: number | null = null;
  biweeklyStartDate: Date | null = null;
  semiMonthlyDay1: number | 'last' | null = null;
  semiMonthlyDay2: number | 'last' | null = null;
  monthlyDay: number | 'last' | null = null;
  selectedCustomDays: { [key: number]: boolean } = {};
  customLastDay: boolean = false;
  summary: string = '';
  token: string;
  constructor(

    private _pagoService: PagoService,
    private _userService: UserService
  ) {
    this.token = this._userService.getToken();

  }
  ngAfterViewInit() {

  }
  ngOnInit() {
    this.getpaymentbyuser();
  }

  getpaymentbyuser() {
    this._pagoService.Getcompanyconfig(this.token)
      .subscribe((response: any) => {
        if (response.status === 'success' && response.config) {
  
          
          this.selectedWeekday = null;
          this.selectedBiweeklyWeekday = null;
          this.biweeklyStartDate = null;
          this.semiMonthlyDay1 = null;
          this.semiMonthlyDay2 = null;
          this.monthlyDay = null;
          this.selectedCustomDays = {};
          this.customLastDay = false;
  
          
          if (
            response.config.frequency === 'MONTHLY' &&
            response.paydays &&
            response.paydays.length === 2 &&
            response.paydays.every(pd => pd.day_of_week === null) &&
            response.paydays.every(pd => pd.day_of_month !== null)
          ) {
            
            this.selectedFrequency = 'SEMIMONTHLY';
            this.semiMonthlyDay1 = response.paydays[0].day_of_month === 0 ? 'last' : response.paydays[0].day_of_month;
            this.semiMonthlyDay2 = response.paydays[1].day_of_month === 0 ? 'last' : response.paydays[1].day_of_month;
          }
        
          else if (response.config.frequency === 'MONTHLY') {
            this.selectedFrequency = response.config.frequency;
            if (response.paydays && response.paydays.length > 0) {
              const payday = response.paydays[0];
              this.monthlyDay = payday.day_of_month === 0 ? 'last' : payday.day_of_month;
            }
          } else if (response.config.frequency === 'SEMIMONTHLY') {
            this.selectedFrequency = response.config.frequency;
            if (response.paydays && response.paydays.length >= 2) {
              this.semiMonthlyDay1 = response.paydays[0].day_of_month === 0 ? 'last' : response.paydays[0].day_of_month;
              this.semiMonthlyDay2 = response.paydays[1].day_of_month === 0 ? 'last' : response.paydays[1].day_of_month;
            }
          } else if (response.config.frequency === 'WEEKLY') {
            this.selectedFrequency = response.config.frequency;
            if (response.paydays && response.paydays.length > 0) {
              this.selectedWeekday = response.paydays[0].day_of_week;
            }
          } else if (response.config.frequency === 'BIWEEKLY') {
            this.selectedFrequency = response.config.frequency;
            if (response.paydays && response.paydays.length > 0) {
              this.selectedBiweeklyWeekday = response.paydays[0].day_of_week;
             
            }
          } else if (response.config.frequency === 'CUSTOM') {
            this.selectedFrequency = response.config.frequency;
            if (response.paydays && response.paydays.length > 0) {
              response.paydays.forEach((pd: any) => {
                if (pd.day_of_month === 0) {
                  this.customLastDay = true;
                } else if (pd.day_of_month) {
                  this.selectedCustomDays[pd.day_of_month] = true;
                }
              });
            }
          }
  
          this.updateSummary();
        }
      });
  }
  
  
  SubmitNewConfig() {
    let paydays: any[] = [];
  
    switch (this.selectedFrequency) {
      case 'WEEKLY':
        if (this.selectedWeekday) {
          paydays.push({ day_of_week: this.selectedWeekday });
        }
        break;
  
      case 'BIWEEKLY':
        if (this.selectedBiweeklyWeekday) {
          let payday: any = { day_of_week: this.selectedBiweeklyWeekday, custom_rule: 'biweekly' };
          if (this.biweeklyStartDate) {
            payday.first_date = this.biweeklyStartDate instanceof Date
              ? this.biweeklyStartDate.toISOString().slice(0, 10)
              : this.biweeklyStartDate;
          }
          paydays.push(payday);
        }
        break;
  
      case 'SEMIMONTHLY':
        if (this.semiMonthlyDay1) {
          paydays.push({ day_of_month: this.semiMonthlyDay1 === 'last' ? 0 : this.semiMonthlyDay1 });
        }
        if (this.semiMonthlyDay2) {
          paydays.push({ day_of_month: this.semiMonthlyDay2 === 'last' ? 0 : this.semiMonthlyDay2 });
        }
        break;
  
      case 'MONTHLY':
        if (this.monthlyDay) {
          paydays.push({ day_of_month: this.monthlyDay === 'last' ? 0 : this.monthlyDay });
        }
        break;
  
      case 'CUSTOM':
        Object.keys(this.selectedCustomDays)
          .filter(day => this.selectedCustomDays[+day])
          .forEach(day => paydays.push({ day_of_month: +day }));
        if (this.customLastDay) {
          paydays.push({ day_of_month: 0 });
        }
        break;
    }
  
    let payload = {
      frequency: this.selectedFrequency,
      paydays: paydays
    };
  
    this._pagoService.SetCompanyConfig(this.token, payload  )
      .subscribe((response: any) => {
        if(response.status == "success"){
          this.showToast('success', 'New config has been Saved', 2000);
        }else{
          this.showToast('error', 'Ops Something went wrong.', 2000);
        }
      }, err => {
    
        this.showToast('error', 'Ops Something went wrong.', 2000);
      });
  }
  











  onFrequencyChange() {
    
    this.selectedWeekday = null;
    this.selectedBiweeklyWeekday = null;
    this.biweeklyStartDate = null;
    this.semiMonthlyDay1 = null;
    this.semiMonthlyDay2 = null;
    this.monthlyDay = null;
    this.selectedCustomDays = {};
    this.customLastDay = false;
    this.updateSummary();
  }

  updateSummary() {
    switch (this.selectedFrequency) {
      case 'WEEKLY':
        if (this.selectedWeekday) {
          this.summary = `Payments are issued every ${this.weekDays[this.selectedWeekday - 1].label}.`;
        } else {
          this.summary = '';
        }
        break;
      case 'BIWEEKLY':
        if (this.selectedBiweeklyWeekday && this.biweeklyStartDate) {
          this.summary = `Payments are issued every other ${this.weekDays[this.selectedBiweeklyWeekday - 1].label}, starting on ${this.biweeklyStartDate.toLocaleDateString()}.`;
        } else {
          this.summary = '';
        }
        break;
      case 'SEMIMONTHLY':
        if (this.semiMonthlyDay1 && this.semiMonthlyDay2) {
          const days = [this.semiMonthlyDay1, this.semiMonthlyDay2]
            .map(d => d === 'last' ? 'last day of the month' : `${d}`)
            .join(' and ');
          this.summary = `Payments are issued on the ${days} of each month.`;
        } else {
          this.summary = '';
        }
        break;
      case 'MONTHLY':
        if (this.monthlyDay) {
          this.summary = `Payments are issued on the ${this.monthlyDay === 'last' ? 'last day' : this.monthlyDay + 'th'} of each month.`;
        } else {
          this.summary = '';
        }
        break;
      case 'CUSTOM':
        const days = Object.keys(this.selectedCustomDays)
          .filter(day => this.selectedCustomDays[+day])
          .map(day => Number(day));
        let text = 'Payments are issued on ';
        if (days.length > 0) {
          text += days.join(', ');
          text += days.length === 1 ? ' day' : ' days';
        }
        if (this.customLastDay) {
          if (days.length > 0) text += ' and ';
          text += 'the last day of the month';
        }
        if (days.length === 0 && !this.customLastDay) text = '';
        this.summary = text;
        break;
      default:
        this.summary = '';
    }
  }
  get isConfigValid(): boolean {
    switch (this.selectedFrequency) {
      case 'WEEKLY':
        return !!this.selectedWeekday;
      case 'BIWEEKLY':
    
        return !!this.selectedBiweeklyWeekday; 
      case 'SEMIMONTHLY':
        return !!this.semiMonthlyDay1 && !!this.semiMonthlyDay2;
      case 'MONTHLY':
        return !!this.monthlyDay;
      case 'CUSTOM':
      
        const anyCustomDay = Object.values(this.selectedCustomDays).some(val => val);
        return anyCustomDay || this.customLastDay;
      default:
        return false;
    }
  }
  

  showToast(type, title, timer) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: timer,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    })
    Toast.fire({
      icon: type,
      title: title
    });
  }
}